/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { bgColor, opBgColor } from '../../../../redux/multipleChoice/mcq.action';
import ColorPickerComponent from '../../../customizeComponentLayout/colorPicker';

interface SectionCustomizeProps {
  isOptionBgChanged: boolean;
}

const mapState = ({ mcqform }: any) => ({
  bgColor: mcqform.bgColor,
});

const mapDispatch = (dispatch: Function) => ({
  BgColor: (form: {}) => dispatch(bgColor(form)),
  OpBgColor: (form: {}) => dispatch(opBgColor(form)),
});

const connector = connect(mapState, mapDispatch);

type PropsFromRedux = ConnectedProps<typeof connector>;

type Props = PropsFromRedux & SectionCustomizeProps;

const SectionCustomize = (props: Props) => {
  const { bgColor, BgColor, OpBgColor, isOptionBgChanged } = props;
  const handleBgColorChange = (props: { bgColor: string }) => {
    BgColor({ bgColor: props.bgColor });
    if (isOptionBgChanged) return;
    OpBgColor({ opBgColor: props.bgColor });
  };
  return (
    <>
      <ColorPickerComponent
        type='questionBgColor'
        title='Background'
        SetColor={handleBgColorChange}
        color={bgColor}
      />
    </>
  );
};

export default connector(SectionCustomize);
